<!--
 * @Author: zl
 * @Date: 2022-03-29 14:04:20
 * @LastEditTime: 2023-01-06 14:43:11
 * @LastEditors: zl
 * @Description: 基础资料查看弹窗
-->
<template>
	<div v-if="showMode == 'content'">
		<div class="content-header">
			<div class="left">
				<el-tabs v-model="activeName"
						 @tab-click="tabClick">
					<el-tab-pane label="项目资料"
								 name="0"></el-tab-pane>
					<el-tab-pane label="审计资料"
								 name="1"></el-tab-pane>
					<el-tab-pane label="三方巡查资料"
								 name="2"></el-tab-pane>
					<el-tab-pane label="其他资料"
								 name="3"></el-tab-pane>
					<el-tab-pane label="项目相册"
								 name="4"></el-tab-pane>
				</el-tabs>
			</div>
			<div class="right"
				 v-if="activeName != '4'">
				<el-select v-model="openLevel"
						   size="small"
						   class="ml10"
						   @change="levelChange">
					<el-option v-for="n in maxLevel"
							   :key="'level' + n"
							   :value="n"
							   :label="`展开到${n}级`">
					</el-option>
				</el-select>
				<el-button size="small"
						   class="ml10 btn-success"
						   type="success"
						   icon="el-icon-refresh"
						   @click="openAll"></el-button>
			</div>
		</div>

		<div class="content-box"
			 style="height: 650px !important">
			<template v-if="activeName == '0'">
				<vxe-table align="center"
						   auto-resize
						   border
						   :data="tableObj.data"
						   ref="fileTable"
						   key="1001"
						   height="650px"
						   highlight-current-row
						   highlight-hover-row
						   :loading="tableObj.loading"
						   show-overflow="tooltip"
						   show-header-overflow="tooltip"
						   :tree-config="{children: 'children'}">
					<vxe-table-column type="seq"
									  title="序号"
									  width="65px"></vxe-table-column>
					<vxe-table-column field="sname"
									  title="资料清单"
									  tree-node
									  header-align="center"
									  align="left"
									  min-width="400">
						<template #default="{ row }">
							<i v-if="row.pid == '0'"
							   class="el-icon-folder-opened mr5"></i>
							<i v-else
							   class="el-icon-tickets mr5"></i>
							<el-tooltip effect="dark"
										:content="row.remark"
										:disabled="row.level == 0 || row.level == 1 || !row.remark"
										placement="top">
								<span>{{ row.sname }}</span>
							</el-tooltip>
						</template>
					</vxe-table-column>
					<vxe-table-column field="fileSnames"
									  title="资料名称"
									  align="center"
									  width="300">
						<template v-slot="{ row }">
							<span v-if="row.fileList && row.fileList.length == 0 && row.fileNum > 0">
								共 {{ row.fileNum }} 个文件
							</span>
							<span v-else-if="!!row.fileList && row.fileList.length > 0"
								  class="blue-text vxe-cell--label"
								  @click="viewFile(row)">
								查看（共 {{ row.fileList.length }} 个文件）
							</span>
							<span v-else>-</span>
						</template>
					</vxe-table-column>
				</vxe-table>
			</template>
			<template v-else-if="['1', '2', '3'].includes(this.activeName)">
				<w-split v-model="splitValue">
					<div slot="left">
						<el-tree :data="treeObj.data"
								 :props="treeObj.props"
								 default-expand-all
								 node-key="id"
								 @node-click="treeClick"
								 ref="treeTable"
								 :current-node-key="defaultChceked"
								 highlight-current>
							<div class="tree-style"
								 slot-scope="{node, data}">
								<i class="el-icon-folder-opened mr5"></i>
								<template v-if="activeName == '1'">
									<span>{{ data.packName }}</span>
									<span v-if="data.id != '10005'">（ {{ data.auditTypeName }} ）</span>
								</template>
								<template v-else>
									<span class="text-overflow">{{ data.sname }}</span>
								</template>
							</div>
						</el-tree>
					</div>
					<div slot="right">
						<vxe-table align="center"
								   auto-resize
								   border
								   :data="tableObj.data"
								   ref="fileTable"
								   key="1001"
								   height="650px"
								   highlight-current-row
								   highlight-hover-row
								   :loading="tableObj.loading"
								   show-overflow="tooltip"
								   show-header-overflow="tooltip"
								   :tree-config="{children: 'children'}">
							<vxe-table-column type="seq"
											  title="序号"
											  width="65px"></vxe-table-column>
							<vxe-table-column field="sname"
											  title="资料清单"
											  tree-node
											  header-align="center"
											  align="left"
											  min-width="400">
								<template #default="{ row }">
									<i v-if="row.pid == '0'"
									   class="el-icon-folder-opened mr5"></i>
									<i v-else
									   class="el-icon-tickets mr5"></i>
									<el-tooltip effect="dark"
												:content="row.remark"
												:disabled="row.level == 0 || row.level == 1 || !row.remark"
												placement="top">
										<span>{{ row.sname }}</span>
									</el-tooltip>
								</template>
							</vxe-table-column>
							<vxe-table-column field="fileSnames"
											  title="资料名称"
											  align="center"
											  width="300">
								<template v-slot="{ row }">
									<span v-if="row.fileList && row.fileList.length == 0 && row.fileNum > 0">
										共 {{ row.fileNum }} 个文件
									</span>
									<span v-else-if="!!row.fileList && row.fileList.length > 0"
										  class="blue-text vxe-cell--label"
										  @click="viewFile(row)">
										查看（共 {{ row.fileList.length }} 个文件）
									</span>
									<span v-else>-</span>
								</template>
							</vxe-table-column>
						</vxe-table>
					</div>
				</w-split>
			</template>
			<template v-else>
				<Images :projectId="this.currentRow.id"
						diaWidth="500px"></Images>
			</template>
		</div>

		<!-- 文件弹窗 -->
		<el-dialog title="文件列表"
				   :visible.sync="fileObj.show"
				   width="1200px"
				   append-to-body
				   :close-on-click-modal="false"
				   :before-close="closeFile"
				   center>
			<vxe-table align="center"
					   border
					   :data="fileObj.data"
					   highlight-current-row
					   highlight-hover-row
					   show-overflow="tooltip"
					   show-header-overflow="tooltip">
				<vxe-table-column type="seq"
								  title="序号"
								  width="65"></vxe-table-column>
				<vxe-table-column field="fileName"
								  title="资料名称"
								  min-width="280px"
								  header-align="center"
								  align="left">
					<template #default="{ row }">
						<FileName style="width: 95%"
								  :fileName="row.fileName"
								  :filePath="row.filePath"
								  :fileSize="row.fileSize"></FileName>
					</template>
				</vxe-table-column>
				<vxe-table-column field="redactUnit"
								  title="文件编制单位"
								  header-align="center"
								  align="left"
								  width="150"></vxe-table-column>
				<vxe-table-column field="captureDate"
								  title="创建日期"
								  width="150"></vxe-table-column>
				<vxe-table-column field="createUser"
								  title="上传人"
								  width="150"></vxe-table-column>
				<vxe-table-column field="shortName"
								  title="上传单位"
								  width="150">
					<template #default="{ row }">
						<el-tooltip effect="dark"
									:content="row.upUnit"
									placement="top">
							<span class="vxe-cell--label">{{ row.shortName }}</span>
						</el-tooltip>
					</template>
				</vxe-table-column>
				<vxe-table-column field="createDate"
								  title="上传时间"
								  width="150"></vxe-table-column>
			</vxe-table>
		</el-dialog>
	</div>
	<el-dialog v-else
			   :title="dialogObj.title"
			   :visible.sync="dialogObj.show"
			   width="1200px"
			   :close-on-click-modal="false"
			   :close-on-press-escape="false"
			   append-to-body
			   top="6vh"
			   center
			   @close="dialogClose">
		<div class="content-header">
			<div class="left">
				<el-tabs v-model="activeName"
						 @tab-click="tabClick">
					<el-tab-pane label="项目资料"
								 name="0"></el-tab-pane>
					<el-tab-pane label="审计资料"
								 name="1"></el-tab-pane>
					<el-tab-pane label="三方巡查资料"
								 name="2"></el-tab-pane>
					<el-tab-pane label="其他资料"
								 name="3"></el-tab-pane>
					<el-tab-pane label="项目相册"
								 name="4"></el-tab-pane>
				</el-tabs>
			</div>
			<div class="right"
				 v-if="activeName != '4'">
				<el-select v-model="openLevel"
						   size="small"
						   class="ml10"
						   @change="levelChange">
					<el-option v-for="n in maxLevel"
							   :key="'level' + n"
							   :value="n"
							   :label="`展开到${n}级`">
					</el-option>
				</el-select>
				<el-button size="small"
						   class="ml10 btn-success"
						   type="success"
						   icon="el-icon-refresh"
						   @click="openAll"></el-button>
			</div>
		</div>

		<div class="content-box">
			<template v-if="activeName == '0'">
				<vxe-table align="center"
						   auto-resize
						   border
						   :data="tableObj.data"
						   ref="fileTable"
						   key="1001"
						   height="500px"
						   highlight-current-row
						   highlight-hover-row
						   :loading="tableObj.loading"
						   show-overflow="tooltip"
						   show-header-overflow="tooltip"
						   :tree-config="{children: 'children'}">
					<vxe-table-column type="seq"
									  title="序号"
									  width="65px"></vxe-table-column>
					<vxe-table-column field="sname"
									  title="资料清单"
									  tree-node
									  header-align="center"
									  align="left"
									  min-width="400">
						<template #default="{ row }">
							<i v-if="row.pid == '0'"
							   class="el-icon-folder-opened mr5"></i>
							<i v-else
							   class="el-icon-tickets mr5"></i>
							<el-tooltip effect="dark"
										:content="row.remark"
										:disabled="row.level == 0 || row.level == 1"
										placement="top">
								<span>{{ row.sname }}</span>
							</el-tooltip>
						</template>
					</vxe-table-column>
					<vxe-table-column field="fileSnames"
									  title="资料名称"
									  align="center"
									  width="300">
						<template v-slot="{ row }">
							<span v-if="row.fileList && row.fileList.length == 0 && row.fileNum > 0">
								共 {{ row.fileNum }} 个文件
							</span>
							<span v-else-if="!!row.fileList && row.fileList.length > 0"
								  class="blue-text vxe-cell--label"
								  @click="viewFile(row)">
								查看（共 {{ row.fileList.length }} 个文件）
							</span>
							<span v-else>-</span>
						</template>
					</vxe-table-column>
				</vxe-table>
			</template>
			<template v-else-if="activeName == '4'">
				<Images :projectId="this.currentRow.id"
						diaWidth="500px"></Images>
			</template>
			<template v-else>
				<w-split v-model="splitValue">
					<div slot="left">
						<el-tree :data="treeObj.data"
								 :props="treeObj.props"
								 default-expand-all
								 node-key="id"
								 @node-click="treeClick"
								 ref="treeTable"
								 :current-node-key="defaultChceked"
								 highlight-current>
							<div class="tree-style"
								 slot-scope="{node, data}">
								<i class="el-icon-folder-opened mr5"></i>
								<template v-if="activeName == '1'">
									<span>{{ data.packName }}</span>
									<span v-if="data.id != '10005'">（ {{ data.auditTypeName }} ）</span>
								</template>
								<template v-else>
									<span class="text-overflow">{{ data.sname }}</span>
								</template>
							</div>
						</el-tree>
					</div>
					<div slot="right">
						<vxe-table align="center"
								   auto-resize
								   border
								   :data="tableObj.data"
								   ref="fileTable"
								   key="1001"
								   height="500px"
								   highlight-current-row
								   highlight-hover-row
								   :loading="tableObj.loading"
								   show-overflow="tooltip"
								   show-header-overflow="tooltip"
								   :tree-config="{children: 'children'}">
							<vxe-table-column type="seq"
											  title="序号"
											  width="65px"></vxe-table-column>
							<vxe-table-column field="sname"
											  title="资料清单"
											  tree-node
											  header-align="center"
											  align="left"
											  min-width="400">
								<template #default="{ row }">
									<i v-if="row.pid == '0'"
									   class="el-icon-folder-opened mr5"></i>
									<i v-else
									   class="el-icon-tickets mr5"></i>
									<el-tooltip effect="dark"
												:content="row.remark"
												:disabled="row.level == 0 || row.level == 1"
												placement="top">
										<span>{{ row.sname }}</span>
									</el-tooltip>
								</template>
							</vxe-table-column>
							<vxe-table-column field="fileSnames"
											  title="资料名称"
											  align="center"
											  width="300">
								<template v-slot="{ row }">
									<span v-if="row.fileList && row.fileList.length == 0 && row.fileNum > 0">
										共 {{ row.fileNum }} 个文件
									</span>
									<span v-else-if="!!row.fileList && row.fileList.length > 0"
										  class="blue-text vxe-cell--label"
										  @click="viewFile(row)">
										查看（共 {{ row.fileList.length }} 个文件）
									</span>
									<span v-else>-</span>
								</template>
							</vxe-table-column>
						</vxe-table>
					</div>
				</w-split>
			</template>
		</div>
		<!-- <div slot="footer"
			 class="custom-dialog-footer">
			<el-button class="btn"
					   @click="dialogObj.show = false">取 消</el-button>
		</div> -->

		<!-- 文件弹窗 -->
		<el-dialog title="文件列表"
				   :visible.sync="fileObj.show"
				   width="1000px"
				   append-to-body
				   :close-on-click-modal="false"
				   :before-close="closeFile"
				   center>
			<vxe-table align="center"
					   border
					   :data="fileObj.data"
					   highlight-current-row
					   highlight-hover-row
					   show-overflow="tooltip"
					   show-header-overflow="tooltip">
				<vxe-table-column type="seq"
								  title="序号"
								  width="65"></vxe-table-column>
				<vxe-table-column field="fileName"
								  title="资料名称"
								  header-align="center"
								  align="left">
					<template #default="{ row }">
						<FileName :fileName="row.fileName"
								  :filePath="row.filePath"
								  :fileSize="row.fileSize"></FileName>
					</template>
				</vxe-table-column>
				<vxe-table-column field="redactUnit"
								  title="文件编制单位"
								  header-align="center"
								  align="left"></vxe-table-column>
				<vxe-table-column field="createUser"
								  title="上传人"></vxe-table-column>
				<vxe-table-column field="shortName"
								  title="上传单位">
					<template #default="{ row }">
						<el-tooltip effect="dark"
									:content="row.upUnit"
									placement="top">
							<span class="vxe-cell--label">{{ row.shortName }}</span>
						</el-tooltip>
					</template>
				</vxe-table-column>
				<vxe-table-column field="createDate"
								  title="上传时间"></vxe-table-column>
			</vxe-table>
		</el-dialog>
	</el-dialog>
</template>

<script>
import { getProjectFileData } from '@/api/upload/upload'
import * as API from '@/api/BasicData/BasicDataIndex'
import ProjectImages from '@/views/Common/ProjectImages'
import Images from '@/views/Common/Images'
export default {
	name: '',
	props: {
		currentRow: {
			type: Object,
			default: () => {
				return {}
			},
		},
		showMode: {
			type: String,
			default: 'dialog',
		},
	},
	components: { ProjectImages, Images },
	data() {
		return {
			activeName: '0',
			splitValue: 0.25,
			dialogObj: {
				title: '',
				show: false,
			},
			treeObj: {
				data: [],
				show: false,
				props: {
					children: 'children',
					label: 'packName',
				},
			},
			tableObj: {
				data: [],
				loading: false,
			},
			fileObj: {
				show: false,
				data: [],
			},
			defaultChceked: '',
			openLevel: 3,
			maxLevel: 5,
		}
	},
	created() {
		// 获取项目资料
		this.getProjectFiles()
		this.dialogObj.title = this.currentRow.sname + '基础资料'
	},
	methods: {
		// 获取项目资料
		getProjectFiles() {
			this.tableObj.loading = true
			getProjectFileData({
				projectId: this.currentRow.id,
				tableName: 'bus_project',
			})
				.then((res) => {
					this.tableObj.data = res.data
					this.tableObj.loading = false
					this.maxLevel = res.data[0].maxLevel + 1
					this.openLevel = this.maxLevel >= 2 ? 2 : this.maxLevel
					setTimeout(() => {
						if (this.$refs.fileTable) {
							this.levelChange(this.openLevel)
						}
					}, 200)
				})
				.catch(() => {
					this.tableObj.loading = false
				})
		},

		// 获取审计资料左侧数据
		getTreeData() {
			if (this.activeName == '1') {
				API.getTaskFileListByProject({
					projectId: this.currentRow.id,
					permissionSwitch: 1, //是否根据权限查询 1是
					isOutSide: '1', //是否项目外的查询 目前要求查询全部  增加参数作为判断
				}).then((res) => {
					if (res.data.length > 0) {
						this.treeObj.data = [
							{
								id: '10005',
								auditTypeName: '',
								packName: '审计任务',
								children: [],
							},
						]
						res.data.forEach((x) => {
							x.children = []
							this.treeObj.data[0].children.push(x)
						})
						this.getReportFile(res.data[0].id)
						this.$nextTick(() => {
							this.defaultChceked = res.data[0].id
							this.$refs.treeTable.setCurrentKey(res.data[0].id)
						})
					} else {
						this.treeObj.data = []
						this.tableObj.data = []
					}
				})
				return
			}
			if (this.activeName == '2') {
				this.tableObj.loading = true
				API.getTripartiteInspectionTreeInfo({
					projectId: this.currentRow.id,
				}).then((res) => {
					if (res.data.length > 0) {
						let acceptData = this.$utils.clone(res.data, true)
						this.treeObj.data = [
							{
								id: '1000086',
								sname: '三方巡查资料',
								children: [],
							},
						]
						this.treeObj.data[0].children = acceptData.filter(
							(x) => {
								if (!x.moduleType) {
									x.children = []
									return x
								}
							}
						)

						this.tableObj.data = [
							{
								id: '1000086',
								sname: '三方巡查资料',
								level: 0,
								children: [],
								fileList: [],
								moduleType: '',
								type: 1000,
							},
						]
						this.tableObj.data[0].children =
							this.tableObj.data[0].children.concat(res.data)
						this.copyData = this.$utils.clone(
							this.tableObj.data,
							true
						)
						this.$nextTick(() => {
							this.defaultChceked = res.data[0].id
							this.$refs.treeTable.setCurrentKey(res.data[0].id)
							this.treeClick(res.data[0], true)
						})

						let maxLevel = this.computedLevel(this.tableObj.data)
						this.maxLevel = maxLevel
						this.openLevel = this.maxLevel >= 2 ? 2 : this.maxLevel
						this.levelChange(this.openLevel)
					} else {
						this.treeObj.data = []
						this.tableObj.data = []
					}
				})
			}
			if (this.activeName == '3') {
				API.getPackTree({ projectId: this.currentRow.id }).then(
					(res) => {
						if (!!res.data) {
							this.treeObj.data = [res.data]
							this.$nextTick(() => {
								if (
									!!res.data.children &&
									res.data.children.length > 0
								) {
									this.$refs.treeTable.setCurrentKey(
										res.data.children[0].id
									)
									this.treeClick(res.data.children[0], true)
								} else {
									this.$refs.treeTable.setCurrentKey(
										res.data.id
									)
									this.treeClick(res.data, true)
								}
							})
						}
					}
				)
			}
		},

		// 计算最高层级
		computedLevel(treeData) {
			let level = 0
			let that = this
			let maxLevel = 0
			function loop(data, level) {
				data.forEach((x) => {
					x.level = level
					if (level > maxLevel) {
						maxLevel = level
					}
					if ('children' in x) {
						if (x.children.length > 0) {
							loop(x.children, level + 1)
						}
					}
				})
			}
			loop(treeData, 1)
			return maxLevel
		},

		// 获取委托报审资料
		getReportFile(id) {
			this.tableObj.loading = true
			API.getFiles({
				taskId: id,
				supplementSign: '1',
			})
				.then((res) => {
					this.tableObj.data = res.data
					this.tableObj.loading = false
					this.maxLevel = res.data[0].maxLevel + 1
					this.openLevel = this.maxLevel >= 2 ? 2 : this.maxLevel
					this.levelChange(this.openLevel)
				})
				.catch(() => {
					this.tableObj.loading = false
				})
		},

		// 其他资料左侧树节点点击
		otherTreeClick(data) {
			const params = {
				projectId: this.currentRow.id,
				packId: data.id,
			}
			if (data.type && data.type == '1') {
				delete params.packId
			}
			this.tableObj.loading = true
			API.getOtherFiles(params)
				.then((res) => {
					this.tableObj.data = res.data
					this.tableObj.loading = false
					this.maxLevel = res.data[0].maxLevel
						? parseInt(res.data[0].maxLevel) + 1
						: 1
					this.openLevel = this.maxLevel >= 2 ? 2 : this.maxLevel
					this.levelChange(this.openLevel)
				})
				.catch(() => {
					this.tableObj.loading = false
				})
		},

		// tab 点击事件
		tabClick(data) {
			if (data.name != '0') {
				this.defaultChceked = ''
				this.getTreeData()
				return
			}
			this.getProjectFiles()
		},

		// 左侧树点击事件
		treeClick(data, first) {
			if (this.activeName == '1') {
				if (data.id == '0') {
					return
				}
				this.getReportFile(data.id)
				return
			}
			if (this.activeName == '3') {
				this.otherTreeClick(data)
				return
			}
			this.tableObj.data = this.$utils.searchTree(
				this.copyData,
				(item) => item.id == data.id
			)
			this.tableObj.loading = true
			if (!first) {
				this.openAll()
			} else {
				this.levelChange(2)
				this.tableObj.loading = false
			}
		},

		// 展开所有
		openAll() {
			this.tableObj.loading = true
			this.openLevel = 2
			setTimeout(() => {
				if (this.$refs.fileTable) {
					// this.$refs.fileTable.setAllTreeExpand(true)
					this.levelChange(2)
				}
				this.tableObj.loading = false
			}, 200)
		},

		// 展开层级
		levelChange(level) {
			// 先关闭所有
			this.$refs.fileTable.clearTreeExpand()

			// 找到对应层级的数组
			let arr = this.$utils.filterTree(
				this.tableObj.data,
				(x) => x.level < level - 1
			)
			this.$refs.fileTable.setTreeExpand(arr, true)
		},

		// 弹窗关闭
		dialogClose() {
			this.dialogObj.show = false
			this.$emit('sendClose', false)
		},

		// 查看弹窗
		viewFile(data) {
			if (data.fileList) {
				this.fileObj.data = data.fileList
			} else {
				this.fileObj.data.push(data.sysFile)
			}
			this.fileObj.show = true
		},

		// 查看弹窗关闭
		closeFile() {
			this.fileObj.data = []
			this.fileObj.show = false
		},
	},
	computed: {},
}
</script>
<style lang='less' scoped>
.content-header {
	display: flex;
	justify-content: space-between;
}
.content-box {
	height: 650px !important;
}
.btn {
	padding: 0px 50px;
}
</style>